import {COMMANDE_ROUTES as commandeRoutes, RDV_ROUTES as rdvRoutes} from "~/api/routes";

export const state = () => ({
  commandes: null,
  pagination:{}
});

export const getters = {
  commandes: state => state.commandes,
  pagination: state => state.pagination,
};
export const mutations = {
  SET_COMMANDES(state, commandes) {
    state.commandes = commandes;
  },
  COMMANDE_PAGINATION(state,pagination){
    delete pagination.data;
    state.pagination = pagination
  },
  UPDATE_STATUT(state, params){
    state.commandes =  state.commandes.map(c =>{
      if (c.commande_id === params.id)
        c.livraison_statut = params.data.statut;
      return c;
    })
  },
};
export const actions = {
  async list({commit},params={}) {
    return new Promise((resolve, reject) => {
      this.$api.request(commandeRoutes.list, {},params)
        .then(res => {
          commit('SET_COMMANDES', res.payload.data);
          commit('COMMANDE_PAGINATION', res.payload);
          resolve(res);
        }).catch(err => {
          reject(err);
      })
    })
  },
  async statut({commit},params={}) {
    return new Promise((resolve, reject) => {
      this.$api.request(commandeRoutes.statut, {id: params.id} , params.data)
        .then(res => {
          commit('UPDATE_STATUT', params);
          resolve(res);
        }).catch(err => {
          console.log(err)
          reject(err);
      })
    })
  },

};
